<template>
  <el-card shadow="never" class="sidebar-card">
    <template #header>
      <span class="card-title">友情链接</span>
    </template>
    <div v-loading="loading" class="friend-links-body">
      <div
        v-for="link in friendLinks"
        :key="link.id"
        class="link-item"
        @click="openLink(link.url)"
      >
        {{ link.name }}
      </div>
      <el-empty
        v-if="!loading && friendLinks.length === 0"
        description="暂无链接"
        :image-size="40"
      />
    </div>
  </el-card>
</template>

<script>
import { getFriendLinkList } from "@/api/friendLink";

export default {
  name: "FriendLinks",
  data() {
    return {
      friendLinks: [],
      loading: false,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        const res = await getFriendLinkList();
        if (res.data.code === 200) {
          this.friendLinks = res.data.data || [];
        }
      } catch (e) {
        console.error("加载友情链接失败:", e);
      } finally {
        this.loading = false;
      }
    },
    openLink(url) {
      if (!url) return;
      window.open(url, "_blank", "noopener,noreferrer");
    },
  },
};
</script>

<style lang="scss" scoped>
.friend-links-body {
  position: relative;
}

.link-item {
  /* 单行省略 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  padding: 12px 0;

  &:last-child {
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }
}
</style>
